export const appColors = {
  'black--70': 'rgba(62, 43, 46, 0.7)', // override of black, so we cannot make mistakes with using #000 black, cause we don't
  'black--0': 'rgba(62, 43, 46, 0)', // override of black, so we cannot make mistakes with using #000 black, cause we don't
  'price-rank-1': '#3D85C6',
  'price-rank-1p': '#A64D79',
  'price-rank-2': '#A8E2F1',
  'price-rank-3': '#8FCE00',
  'price-rank-4': '#38761D',
  'price-rank-5': '#FFF836',
  'price-rank-gold': '#EF900D',
  'primary-1-red--torch': '#E4002B', // Brand color
  'primary-1-red--fire-brick': '#A6192E',
  'primary-1-orange--bittersweet': '#FF585D',
  'primary-grey--black-squeeze': '#F4F4F2', // used for backgrounds
  'primary-grey--black-squeeze--0': 'rgba(244, 244, 244, 0)', // used for backgrounds
  'primary-grey--concrete': '#D9D9D6',
  'primary-grey--light-grey': '#D0D0D0',
  'primary-grey--dark-grey': '#9E9E9E',
  'primary-grey--dim-gray': '#5E5E5E',
  'secondary-1-green--eagle': '#ADA893',
  'secondary-1-brown--tobacco': '#63513D',
  'secondary-1-yellow--napa': '#A69F88',
  'secondary-2-yellow--dark-portica': '#F2C75C',
  'secondary-2-yellow--saffron': '#F1B434',
  'secondary-2-orange--mango-tango': '#CF7F00',
  'secondary-3-orange--atomic-tangerine': '#FF9D6E',
  'secondary-3-orange--peru-tan': '#73391D',
  'secondary-3-orange--romantic': '#FFBE9F',
  'secondary-4-yellow--light-portica': '#EDE04B',
  'secondary-4-yellow--dark-goldenrod': '#B39B00',
  'secondary-4-yellow--khaki': '#F0E991',
  'secondary-5-blue--pale-cornflower': '#A7C6ED',
  'secondary-5-blue--prussian': '#001A72',
  'secondary-5-blue--onahau': '#C3D7EE',
  'secondary-6-red--azalea': '#FABBCB',
  'secondary-6-red--carnation-pink': '#FC9BB3',
  'secondary-6-red--french-rose': '#EF426F',
  'secondary-7-violet--wisteria': '#C1A7E2',
  'secondary-7-violet--purple-heart': '#5F249F',
  'secondary-7-violet--fog': '#D3BEE2',
  'secondary-8-blue--medium-aquamarine': '#71CC98',
  'secondary-8-green--watercourse': '#046A38',
  'secondary-8-green--vista-blue': '#A0DAB3',
  'secondary-8-green--white-ice': '#D3EEDB',
  'secondary-9-blue--iris': '#00AEC7',
  'secondary-9-green--sherpa-blue': '#004F59',
  'secondary-9-green--sherpa-blue--80': 'rgba(0, 79, 89, 0.8)',
  'secondary-9-green--sherpa-blue--0': 'rgba(0, 79, 89, 0)',
  'secondary-9-blue--turquoise': '#67D2DF',
}
